import PathsConfig from "../Config/RoutePaths";
import steps from "../Config/Steps";
import stepsTarjeta from "../Config/StepsTarjeta";

export const reclamoEntregaParams = {
  title: 'Nuevo reclamo de entrega',
  buttonRoute: PathsConfig.ReclamoEntrega,
  showBanner: false,
  steps: steps,
  activeStep: 4,
  breadcrumb: 'De entrega'
};

export const reclamoTarjetaParams = {
  title: 'Credencial Club',
  buttonRoute: PathsConfig.ReclamoTarjeta,
  showBanner: true,
  steps: stepsTarjeta,
  activeStep: 3,
  breadcrumb: 'Credencial Club'
};

export const volver = (history, suscripcion, motivo) => {
  history.push({
    pathname: PathsConfig.ReclamoEdiciones,
    state: {
      suscripcionSelected: suscripcion,
      motivoSelected: motivo,
      detalleSuscripcion: '',
    },
  });
};
